import { StrictNullable } from '@/shared/types/app.types'
import { IdentifierTypeResponse } from '@/api/resources/common/initialization/common-initialization.dto'
import { CommonCenterResponse } from '@/api/services/common/center/common-center.dto'

export enum PatientFusionMode {
    MAINTAIN = 'maintain',
    DELETE = 'delete'
}

export interface PatientFusionModalState {
    patientToDelete: StrictNullable<any>// PatientWithAllIdsResponse
    patientToMaintain: StrictNullable<any>// PatientWithAllIdsResponse
    searchType: StrictNullable<PatientFusionMode>
    identifierTypes: IdentifierTypeResponse[]
    centers: CommonCenterResponse[]
}
export const initialPatientFusionModalState =
    (): PatientFusionModalState => ({
        patientToDelete: null,
        patientToMaintain: null,
        searchType: null,
        identifierTypes: [],
        centers: []
    })
